<header>
  <div class="nav">
    <a routerLink="/" class="logo" tabindex="-1">
      <img class='logo-icon' src="/assets/app-logo.svg" alt="ABBYY® FlexiCapture® Cloud" />
    </a>
    <ui-lens-beacon name="capture"></ui-lens-beacon>
  </div>
  <div class="user">
    <notifications></notifications>
    <button class="drop-down profile" [uiMenu]="profile">{{userName}}</button>
    <ui-menu #profile>
      <!--<ui-menu-item>View profile</ui-menu-item>-->
      <ui-menu-item (click)="changeRegion()">
        <svg-icon class="icon" src="/assets/icons/region.svg"></svg-icon>
        <span>Change region</span>
      </ui-menu-item>
      <ui-menu-item (click)="logout()">
        <svg-icon class="icon" src="/assets/icons/logout.svg"></svg-icon>
        <span>Log out</span>
      </ui-menu-item>
    </ui-menu>
  </div>
</header>

<div class="content">
  <div class="content-container" [ngClass]="{background: showBackground}">
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
  <sidebar></sidebar>
</div>

<footer>
  <div class="docs">
    <a href="{{linkPrivatePolicy}}">Privacy Notice</a>
    <a href="{{linkCookiePolicy}}">Cookie Policy</a>
    <a href="javascript:Cookiebot.renew()">Cookie Management</a>
    <a href="{{settings.tos.url}}">Terms of Service</a>
  </div>
  <div class="nav">
    <a target="_blank" href="https://www.abbyy.com/">About us</a>
    <a target="_blank" href="https://help.abbyy.com/en-us/flexicapture/12/cloud/rest_api">Help</a>
  </div>
  <div class="copyright">© 2022 ABBYY Development, Inc.</div>
</footer>
